import React from 'react';
import { injectIntl } from 'react-intl';

import FieldLabel from './FieldLabel';

const Radiobutton = (props) => {
	let v = (props.value) ? props.value : (props.model != undefined && props.model[props.name] || '');

	if(v === "0") v = 0;
	if(v === "1") v = 1;

	const checked = props?.checked ?? false;
	const disabled = props?.disabled ?? false;

	let classname = props?.classname ?? 'input radio';
	let classes = classname.split(" ");
	if(props._class) {
		for(let i in props._class) {
			switch(i) {
				case 'first':
					classes.push('first_child');
					break;

				default:
					classes.push(props._class[i]);
					break;
			}
		}
	}

	classname = classes.join(" ");

	let field_class = ['common_form_item'];
	if(disabled) field_class.push('disabledField');

	return (
		<div class={classname}>
			<input
				id={props.value}
				name={props.name}
				disabled={disabled}
				value={props.value}
				class={field_class.join(" ")}
				onChange={(e) => props.change(e.target.value)}
				type="radio"
				style={props.style}
				checked={checked}
			/>

			<FieldLabel
				{...props.label_props}
				name={props.name}
				autotranslate={props.autotranslate}
				tooltip={props.tooltip}
			>{props.children}</FieldLabel>

			{props.errors && props.errors[props.name] && (
				<div class="gui_error_field redIcon">
					{props.errors[props.name]}
				</div>
			)}
		</div>
	);
}

export default injectIntl(Radiobutton);